// extracted by mini-css-extract-plugin
export default {"pe-icon-7-stroke":"_5D3pAqkm"};